import * as types from './types'
import storage from '@/plugins/storage'
const cleanHub = {
  asTechTool: null,
  isPairInfo: false,
  isToolAvail: false,
  isDeviceAvail: false,
  pairStatusTool: '',
  pairStatusDevice: '',
  pairStatus: '',
  errorMessage: '',
  deviceDetails: {
    ArmFirmware: 0,
    HwRevision: 0,
    IsWifi: false,
    PpcFirmware: 0,
    SerialNumber: 0,
    Vin: ''
  },
  deviceStatus: {
    isAvailable: false,
    v: 0,
    rtt: 0,
    rssi: '',
    rx: 0,
    tx: 0
  },
  pairInfo: {
    appLayerInterface: 0,
    appLayerProtocol: 0,
    serviceRequestId: 0,
    shopSerialNumber: 0,
    toolSerialNumber: 0
  }
}
const cleanVehicle = {
  Id: 0,
  VIN: '',
  Year: 0,
  Odometer: 0,
  Make: {
    Id: 0,
    Text: ''
  },
  Model: {
    Id: 0,
    Text: ''
  },
  Submodel: {
    Id: 0,
    Text: ''
  },
  Engine: {
    Id: 0,
    Liter: '',
    CID: '',
    Cylinders: '',
    BlockType: ''
  },
  DriveType: {
    Id: 0,
    Text: ''
  },
  OdometerUnits: {
    Id: 0,
    Text: ''
  },
  Transmission: {
    Id: 0,
    Text: ''
  },
  Insurance: {
    Id: 0,
    Text: ''
  }
}
const cleanRequest = {
  Id: 0,
  IsMil: null,
  IsSRS: null,
  IsDrivable: null,
  RONumber: '',
  ShopComments: '',
  Contact: {
    Id: 0,
    Username: '',
    GivenName: '',
    FamilyName: '',
    PhoneNumber: '',
    Email: ''
  },
  Location: {
    Id: 0,
    Name: '',
    Address1: '',
    City: '',
    Country: '',
    ZipCode: '',
    Phone: '',
    ContactName: '',
    StateName: '',
    TimeZone: ''
  },
  Device: {
    Id: 0,
    FriendlyName: '',
    SerialNumber: ''
  },
  ScanType: {
    Id: 0,
    Name: ''
  },
  Status: {
    Id: 0,
    Name: ''
  },
  ScanReport: {
    Id: 0,
    InvoiceNumber: null,
    MasterTechnician: null,
    Recommendations: null,
    ScanReadings: null,
    ServiceDetails: null,
    SnapshotData: null,
    TimeCompleted: null,
    CreatedBy: 0,
    CreatedDate: null,
    Status: {
      Id: 0,
      Text: null
    },
    BillingType: {
      Id: 0,
      Text: null
    },
    IsFollowupScan: 0,
    TotalAfterDiscount: null,
    CurrencyCode: null,
    MSRP: 0,
    Discount: 0,
    OtherInvoice: null,
    IsRevised: false,
    MobileReasonText: null,
    MobileNotes: null
  },
  ScheduleDates: [],
  Vehicle: JSON.parse(JSON.stringify(cleanVehicle)),
  CreatedBy: 0,
  CreatedDate: null,
  UpdatedBy: 0,
  UpdatedDate: null,
  AppId: 1
}

const defaultGaugeOptions = {
  renderTo: 'gauge1',
  width: 300,
  height: 200,
  title: false,
  minValue: -1,
  maxValue: 1,
  majorTicks: [
    '-1',
    '-.8',
    '-.6',
    '-.5',
    '-.2',
    '0',
    '.2',
    '.4',
    '.6',
    '.8',
    '1'
  ],
  minorTicks: 3,
  strokeTicks: false,
  colorPlate: '#fff',
  borderShadowWidth: 0,
  borders: false,
  barBeginCircle: false,
  tickSide: 'left',
  numberSide: 'left',
  needleSide: 'left',
  needleType: 'arrow',
  needleWidth: 8,
  colorNeedle: '#222',
  colorNeedleEnd: '#222',
  animationDuration: 1500,
  animationRule: 'linear',
  animationTarget: 'plate',
  barWidth: 0,
  ticksWidth: 50,
  ticksWidthMinor: 15,
  numbersMargin: 0,
  colorNumbers: '#000',
  colorTitle: '#FFFFFF',
  highlights: [{ from: -1, to: 1, color: '#FFFFFF' }],
  linearGaugeType: 1,
  colorPlateBack: '#FF0000',
  value: 0.0
}

export default {
  pageSize: storage.session.getItem(types.REQUEST_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.REQUEST_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.REQUEST_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.REQUEST_ORDER_BY) || 'Id',
  filterBy: parseInt(storage.local.getItem(types.REQUEST_FILTER_BY)) || null,
  retrospectiveDay: storage.session.getItem(types.REQUEST_RETRO_DAY) || 14,
  status: storage.local.getItem(types.REQUEST_STATUS) || 'ALL',
  syncColumns: storage.local.getItem(types.SYNC_COLUMNS) !== undefined && storage.local.getItem(types.SYNC_COLUMNS) !== null ? JSON.parse(storage.local.getItem(types.SYNC_COLUMNS)) : false,
  cleanRequest: cleanRequest,
  cleanVehicle: cleanVehicle,
  requests: [],
  request: JSON.parse(JSON.stringify(cleanRequest)),
  requestCount: {
    pending: 0,
    inprocess: 0,
    scheduled: 0,
    completed: 0
  },
  vinSummary: null,
  newVehicle: JSON.parse(JSON.stringify(cleanVehicle)),
  years: [],
  makes: [],
  models: [],
  submodels: [],
  engines: [],
  transmissions: [],
  drivetypes: [],
  id: '',
  scantypes: JSON.parse(storage.local.getItem(types.SESSION_SCANTYPES)) || [],
  statuslist: [],
  requestHistory: [],
  decodeError: '',
  totalUnreadChats: 0,
  requestUnreadReset: 0,
  requestUnreadCount: null,
  noRequest: false,
  hubData: JSON.parse(JSON.stringify(cleanHub)),
  damagePositions: [],
  stateDefaults: null,
  stateAssemblyOptions: [],
  stateSrsOptions: [],
  stateLightOptions: [],
  stateKeyEngineOptions: [],
  stateDamageOptions: [],
  stateDamageLevelOptions: [],
  mobileHandoff: null,
  tools: [],
  devices: [],
  shopDevice: null,
  cleanGaugeOptions: JSON.parse(JSON.stringify(defaultGaugeOptions)),
  calibrateConfiguration: {
    damages: [],
    reasons: [],
    systems: [],
    fixtures: [],
    images: [],
    notes: '',
    state: null,
    recommendations: null,
    aiming: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/state.js